import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowLeftCircle,
  ArrowRightCircle,
  Grid,
  SkipBack,
} from "react-feather";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Utils";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../ReduxToolkit/Store";
import { setSideBarToggle } from "../../ReduxToolkit/Reducers/Layout/LayoutReducer";

export default function LogoWrapper() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sideBarToggle } = useSelector((state: RootState) => state.layout);
  const handleSidebarToggle = () => {
    dispatch(setSideBarToggle(!sideBarToggle));
  };
  const navigateToApmenu = () => {
    navigate(`/organization-apps`);
  };
  return (
    <div className="logo-wrapper">
      <Link to={`${process.env.PUBLIC_URL}/organization-apps`}>
        <h1 className="logo-text" style={{ color: "white" }}>
          ACERS
        </h1>
        {/* <Image className="img-fluid" src={dynamicImage(`logo/logo_dark.png`)} alt="" /> */}
      </Link>
      <Grid
        className="status_toggle middle sidebar-toggle"
        onClick={navigateToApmenu}
      />

      <div className="back-btn" onClick={handleSidebarToggle}>
        <i className="fa fa-angle-left"></i>
      </div>
      <div className="toggle-sidebar">
        {sideBarToggle ? (
          <ArrowRightCircle
            className="status_toggle middle sidebar-toggle"
            onClick={handleSidebarToggle}
          />
        ) : (
          <ArrowLeftCircle
            className="status_toggle middle sidebar-toggle"
            onClick={handleSidebarToggle}
          />
        )}
      </div>
    </div>
  );
}
